import { ISiteConfig } from "./interfaces/site-config";
import { setColors } from "./utils/colors";
import { setMargins } from "./utils/getMarginClassName";

export let siteConfig: ISiteConfig;

export function setSiteConfig(config: ISiteConfig) {
  siteConfig = config;
  if (config.colors) setColors(config.colors);
  if (config.margins) setMargins(config.margins);
}

export function getSiteConfig(): ISiteConfig {
  return siteConfig;
}
